<ng-template #eventsContent>
    <div class="mx-auto max-w-[1600px]" [style.display]="mixedMode ? 'contents' : null">

        <ng-template #eventsGrid>
            <div class="events-masonry-grid" [class.events-masonry-featured]="featured || gridCols === 4" [class.home-uniform-grid]="uniform" [style.display]="mixedMode ? 'contents' : null" #masonryGrid>
                <article *ngFor="let event of filteredEvents; trackBy: trackById"
                    class="events-masonry-item uniform-card rounded-2xl border border-[#e6e6e6] bg-white p-3 shadow-[0_1px_1px_rgba(0,0,0,0.04)]"
                    [style.order]="mixedMode ? event.globalOrder : null"
                    #eventCardRef>

                    <!-- Removed-by-admin banner (only ever present for the event's own author) -->
                    <div *ngIf="event.isRemovedByAdmin"
                        class="mb-2 flex items-center gap-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs font-medium px-3 py-2">
                        <svg class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                        </svg>
                        <span>This content has been removed by admin and is only visible to you.</span>
                    </div>

                    <div class="flex items-center gap-3">
                        <div class="flex-shrink-0">
                            <!-- NO collaborators: Show single large avatar (40px) -->
                            <img *ngIf="event.acceptedCollaborators.length === 0"
                                class="h-10 w-10 rounded-full object-cover cursor-pointer" [src]="event.hostAvatar"
                                [alt]="event.hostName"
                                (click)="$event.stopPropagation()" [routerLink]="['/profile', event.hostName, 'event']"
                                onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />

                            <!-- HAS collaborators: Show overlapping avatars (Instagram style - max 2 avatars + badge) -->
                            <div *ngIf="event.acceptedCollaborators.length > 0" class="flex -space-x-2 items-center"
                                [class.cursor-pointer]="event.acceptedCollaborators.length >= 1"
                                (click)="event.acceptedCollaborators.length >= 1 ? showCollaboratorsModal(event) : null; $event.stopPropagation()">

                                <!-- Author avatar (always first) -->
                                <img class="h-9 w-9 rounded-full object-cover border-2 border-white"
                                    [src]="event.hostAvatar" [alt]="event.hostName"
                                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />

                                <!-- Show ONLY first collaborator avatar -->
                                <img class="h-7 w-7 rounded-full object-cover border-2 border-white"
                                    [src]="event.acceptedCollaborators[0].profileImage?.urlSmall"
                                    [alt]="event.acceptedCollaborators[0].displayName"
                                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                            </div>
                        </div>
                        <div class="flex-1 min-w-0 overflow-hidden">
                            <div class="font-semibold text-gray-700 text-base truncate">
                                <span class="cursor-pointer" [routerLink]="['/profile', event.hostName, 'event']"
                                    (click)="$event.stopPropagation()">{{ event.hostName }}</span>

                                <!-- 1 collaborator: show name -->
                                <ng-container *ngIf="event.acceptedCollaborators.length === 1">
                                    <span class="font-normal text-gray-500"> with </span>
                                    <span class="font-semibold text-gray-700 cursor-pointer"
                                        [routerLink]="['/profile', event.acceptedCollaborators[0].userName, 'event']"
                                        (click)="$event.stopPropagation()">
                                        {{ event.acceptedCollaborators[0].userName }}
                                    </span>
                                </ng-container>

                                <!-- 2+ collaborators: show "X others" (clickable) -->
                                <ng-container *ngIf="event.acceptedCollaborators.length >= 2">
                                    <span class="font-normal text-gray-500"> and </span>
                                    <span class="font-semibold text-gray-700 cursor-pointer hover:text-gray-900"
                                        (click)="showCollaboratorsModal(event); $event.stopPropagation()">
                                        {{ event.acceptedCollaborators.length }} {{ event.acceptedCollaborators.length
                                        ===
                                        1 ? 'other' : 'others' }}
                                    </span>
                                </ng-container>
                            </div>
                            <div>
                                <p class="text-gray-400 text-[13px] mt-0.5">{{ event.timeAgo }}</p>
                            </div>
                        </div>
                        <div class="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                        <button (click)="onFriendButtonClick(event, $event)"
                            *ngIf="!event.isMyPostedEvent && event.acceptedCollaborators.length === 0"
                            [disabled]="event.friendshipStatus === 'BLOCKED'"
                            [title]="friendButtonTitle(event.friendshipStatus)"
                            class="text-gray-400 flex-shrink-0 transition-colors disabled:opacity-40 disabled:cursor-not-allowed hover:text-[#D31148]">
                            <svg *ngIf="event.friendshipStatus === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24"
                                fill="none" stroke="#D31148" stroke-width="2">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <line x1="19" y1="8" x2="19" y2="14" />
                                <line x1="22" y1="11" x2="16" y2="11" />
                            </svg>
                            <svg *ngIf="event.friendshipStatus === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24"
                                fill="none" stroke="#f97316" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <line x1="17" y1="8" x2="23" y2="14" />
                                <line x1="23" y1="8" x2="17" y2="14" />
                            </svg>
                            <svg *ngIf="event.friendshipStatus === 'PENDING_RECEIVED'" class="h-6 w-6"
                                viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <polyline points="16 11 18 13 22 9" />
                            </svg>
                            <svg *ngIf="event.friendshipStatus === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24"
                                fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <polyline points="16 11 18 13 22 9" />
                            </svg>
                            <svg *ngIf="event.friendshipStatus === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24"
                                fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                            </svg>
                        </button>

                        <!-- Three-dot action menu -->
                        <div class="relative inline-block" (click)="$event.stopPropagation()" *ngIf="!event.isRemovedByAdmin">
                            <button (click)="toggleEventActionMenu(event, $event)"
                                class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 transition-colors text-gray-500">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z" />
                                </svg>
                            </button>
                            <div *ngIf="activeActionEventId === event.id"
                                class="absolute right-0 top-full mt-1 w-44 bg-white rounded-xl shadow-lg border border-gray-100 p-2 z-50">
                                <ng-container *ngIf="event.isMyPostedEvent">
                                    <button (click)="toggleComments(event, $event)" [disabled]="togglingCommentsId === event.id"
                                        class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left rounded-lg disabled:opacity-50"
                                        [ngClass]="event.commentsDisabled ? 'text-red-500 hover:bg-red-50 hover:text-red-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="flex-shrink-0">
                                            <path
                                                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                            <line *ngIf="event.commentsDisabled" x1="2" y1="2" x2="22" y2="22" />
                                        </svg>
                                        {{ event.commentsDisabled ? 'Turn on comments' : 'Turn off comments' }}
                                    </button>
                                    <button (click)="editEvent(event, $event)"
                                        class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="flex-shrink-0">
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                        </svg>
                                        Edit Event
                                    </button>
                                    <button (click)="confirmDeleteEvent(event, $event)"
                                        class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="flex-shrink-0">
                                            <polyline points="3 6 5 6 21 6" />
                                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                            <path d="M10 11v6" />
                                            <path d="M14 11v6" />
                                            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                                        </svg>
                                        Delete Event
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="!event.isMyPostedEvent">
                                    <button *ngIf="!event.isFollowed && event.acceptedCollaborators.length === 0"
                                        (click)="follow($event, event)"
                                        class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="flex-shrink-0">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <line x1="20" y1="8" x2="20" y2="14" />
                                            <line x1="17" y1="11" x2="23" y2="11" />
                                        </svg>
                                        Follow
                                    </button>
                                    <button *ngIf="event.isFollowed && event.acceptedCollaborators.length === 0"
                                        (click)="unfollow($event, event)"
                                        class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="flex-shrink-0">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <line x1="17" y1="11" x2="23" y2="11" />
                                        </svg>
                                        Unfollow
                                    </button>
                                    <button (click)="reportEvent(event, $event)"
                                        class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="flex-shrink-0">
                                            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                                            <line x1="4" y1="22" x2="4" y2="15" />
                                        </svg>
                                        Report Event
                                    </button>
                                    <button (click)="blockUser(event, $event)"
                                        class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="flex-shrink-0">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                                        </svg>
                                        Block User
                                    </button>
                                </ng-container>
                            </div>
                        </div>
                        </div>
                    </div>

                    <!-- Image carousel — natural height, span recalculates on load/slide -->
                    <div class="uniform-media relative mt-3 rounded-xl overflow-hidden">
                        <div class="relative w-full rounded-xl overflow-hidden bg-gray-100 select-none" appSwipe
                            [swipeDisabled]="event.images.length <= 1" (swipeLeft)="onSlideSwipe(event, 1, $event)"
                            (swipeRight)="onSlideSwipe(event, -1, $event)">
                            <img *ngFor="let img of event.images; let i = index" [src]="img" [alt]="event.title"
                                loading="lazy" class="w-full h-auto object-cover cursor-pointer carousel-slide"
                                [class.block]="i === event.activeSlide" [class.hidden]="i !== event.activeSlide"
                                (load)="onEventImageLoad($event)" (click)="goToEvent(event.id)" />
                        </div>

                        <!-- Arrows -->
                        <ng-container *ngIf="event.images.length > 1">
                            <button (click)="prevSlide(event, $event)"
                                class="absolute left-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
                                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M15 18l-6-6 6-6" />
                                </svg>
                            </button>
                            <button (click)="nextSlide(event, $event)"
                                class="absolute right-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
                                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M9 18l6-6-6-6" />
                                </svg>
                            </button>
                        </ng-container>

                    </div>

                    <!-- Slide dots -->
                    <div *ngIf="event.images.length > 1" class="mt-2 flex items-center justify-center gap-1">
                        <button *ngFor="let img of event.images; let i = index" (click)="goToSlide(event, i, $event)"
                            class="rounded-full transition-all duration-300"
                            [class]="i === event.activeSlide ? 'h-2 w-4 bg-[#D31148]' : 'h-2 w-2 bg-[#d9d9d9]'">
                        </button>
                    </div>

                    <ng-container *ngIf="event.totalReactions > 0">
                        <button
                            class="flex items-center mt-3 gap-1.5 cursor-pointer hover:opacity-80 transition-opacity"
                            (click)="openReactionModal(event); $event.stopPropagation()">
                            <!-- Stacked emoji bubbles for top reaction types -->
                            <span class="flex items-center" style="gap:-4px;">
                                <span *ngFor="let t of event.topTypes; let i = index"
                                    class="flex items-center justify-center rounded-full border-2 border-white shadow-sm"
                                    [style.background]="getReactionConfig(t)?.bg" [style.width]="'22px'"
                                    [style.height]="'22px'" [style.font-size]="'13px'" [style.line-height]="'1'"
                                    [style.margin-left]="i > 0 ? '-6px' : '0'" [style.z-index]="10 - i">
                                    {{ getReactionConfig(t)?.emoji }}
                                </span>
                            </span>
                            <!-- "Name and X others" or just count -->
                            <span class="text-sm text-gray-500">
                                <ng-container *ngIf="event.recentUserName">
                                    <span class="font-medium text-gray-700">{{ event.recentUserName }}</span>
                                    <ng-container *ngIf="event.totalReactions > 1">
                                        and {{ event.totalReactions - 1 }} {{ event.totalReactions - 1 === 1 ? 'other' :
                                        'others' }}
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!event.recentUserName">
                                    {{ event.totalReactions }}
                                </ng-container>
                            </span>
                        </button>
                    </ng-container>

                    <!-- Reactions -->
                    <div class="mt-2 flex items-center justify-between">
                        <div class="flex items-center gap-4 text-md text-gray-400">
                            <div class="relative flex items-center gap-1 select-none" style="overflow:visible;">
                                <div *ngIf="event.showEmojiPicker"
                                    class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
                                    style="bottom:calc(100% + 10px);left:-8px;pointer-events:auto;"
                                    (mouseleave)="closeEmojiPicker(event)">
                                    <button *ngFor="let r of REACTIONS; let i = index"
                                        (click)="onEmojiPick(event, r.type, $event)"
                                        (mouseenter)="event.hoveredReaction = r.type"
                                        (mouseleave)="event.hoveredReaction = null"
                                        class="reaction-emoji-btn flex flex-col items-center cursor-pointer"
                                        [style.animation-delay.ms]="i * 30" [title]="r.label">
                                        <span class="reaction-circle flex items-center justify-center rounded-full"
                                            [style.background]="r.bg"
                                            [class.scale-125]="event.hoveredReaction === r.type"
                                            [class.-translate-y-2]="event.hoveredReaction === r.type"
                                            style="width:42px;height:42px;font-size:22px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">
                                            {{ r.emoji }}
                                        </span>
                                    </button>
                                </div>
                                <button
                                    class="flex items-center gap-1.5 rounded-lg px-1 py-0.5 transition-all duration-150 active:scale-90"
                                    (click)="onReactionClick(event)">
                                    <ng-container *ngIf="!event.myReaction">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <g opacity="0.7">
                                                <path
                                                    d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997"
                                                    stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
                                                <path
                                                    d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </g>
                                        </svg>
                                        <span class="text-sm text-gray-400">{{ event.totalReactions }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="event.myReaction">
                                        <span class="reaction-bounce flex items-center justify-center rounded-full"
                                            [style.background]="getReactionConfig(event.myReaction)?.bg"
                                            style="width:30px;height:30px;font-size:18px;line-height:1;">
                                            {{ getReactionConfig(event.myReaction)?.emoji }}
                                        </span>
                                        <span class="text-sm font-semibold"
                                            [style.color]="getReactionConfig(event.myReaction)?.color">
                                            {{ event.totalReactions }}
                                        </span>
                                    </ng-container>
                                </button>
                            </div>
                            <span *ngIf="!event.commentsDisabled" class="flex items-center gap-1 cursor-pointer" (click)="goToEventComments(event.id, $event)">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g opacity="0.7">
                                        <path
                                            d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                </svg>
                                {{ event.comments }}
                            </span>
                            <button class="flex items-center gap-1 hover:text-[#D31148] transition-colors"
                                (click)="openShareSheet(event, $event)">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g opacity="0.7">
                                        <path
                                            d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                </svg>
                                {{ event.shares }}
                            </button>
                        </div>
                        <!-- Tagged people + Favourite star — bottom right -->
                        <div class="flex items-center gap-3">
                            <button *ngIf="event.mentions.length > 0" type="button"
                                (click)="showTaggedPeopleModal(event, $event)" title="Tagged people"
                                class="flex items-center justify-center text-gray-300 transition-colors hover:text-[#D31148]">
                                <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                    <circle cx="9" cy="7" r="4" />
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                            </button>
                            <button (click)="toggleFavourite(event, $event)"
                                [class.text-[#D31148]]="event.isFavourite"
                                [class.text-gray-300]="!event.isFavourite"
                                [title]="event.isFavourite ? 'Remove from favourites' : 'Save to favourites'"
                                class="flex items-center justify-center transition-colors hover:text-[#D31148]">
                                <svg class="h-5 w-5" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round"
                                    [attr.fill]="event.isFavourite ? 'currentColor' : 'none'">
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- Event info -->
                    <div class="mt-3">
                        <div class="uniform-clamp-2 text-lg font-semibold text-gray-800 break-words cursor-pointer hover:text-[#D31148] transition-colors"
                            (click)="goToEvent(event.id)">{{ event.title }}</div>

                        <!-- Price badge -->
                        <div class="mt-1.5 mb-1.5 inline-block rounded-full px-3 py-1 text-xs font-semibold shadow-sm border"
                            [ngClass]="event.minPrice === 0 && event.maxPrice === 0
                                    ? 'bg-green-100 border-green-500 text-green-600'
                                    : 'bg-[#FFD4E0] border-[#D31148] text-[#D31148]'">
                            {{ event.minPrice === 0 && event.maxPrice === 0 ? 'Free' :
                            'Price £' + event.minPrice + ' - £' + event.maxPrice }}
                        </div>

                        <div class="mt-1 text-md text-gray-500">
                            Start Date : <span class="font-medium text-[#000000]">{{ event.startDateLabel }}</span>
                        </div>
                        <div class="text-md text-gray-500 mt-2">
                            End Date : <span class="font-medium text-[#000000]">{{ event.endDateLabel }}</span>
                        </div>
                        <div class="uniform-one-line mt-2 flex items-center gap-1 text-md text-[#000000]">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 1 1 18 0z" />
                                <circle cx="12" cy="10" r="3" />
                            </svg>
                            {{ event?.location || 'Online Event' }}
                        </div>
                    </div>

                    <div *ngIf="event.hashtags.length > 0" class="uniform-one-line mt-3">
                        <div class="flex flex-wrap gap-1.5">
                            <span *ngFor="let tag of event.hashtags" (click)="goToHashtag(tag, $event)"
                                class="inline-block text-sm font-medium text-[#D31148] hover:underline cursor-pointer">
                                #{{ tag }}
                            </span>
                        </div>
                    </div>

                    <!-- Home-page equal-height grid only: pushes the button to the card bottom -->
                    <div class="uniform-spacer"></div>
                    <app-button className="w-full mt-3" size="md" class="mt-2"
                        (click)="goToEvent(event.id)">Event Details</app-button>
                </article>
            </div>

            <div *ngIf="isLoading" class="flex items-center justify-center py-10">
                <div class="h-9 w-9 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
            </div>

            <div *ngIf="!isLoading && events.length === 0 && !mixedMode"
                class="flex flex-col items-center justify-center py-20 text-gray-400">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" class="mb-3 opacity-40">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                <p class="text-sm">No events found</p>
            </div>

            <div #scrollSentinel class="h-4" *ngIf="!mixedMode"></div>
        </ng-template>

        <ng-container *ngIf="!embedded; else embeddedLayout">
            <!-- ── Active filter chips ─────────────────────────────────────────── -->
            <div *ngIf="hasFilters" class="mb-5 rounded-2xl border border-[#e8e8e8] bg-white px-4 py-3">
                <div class="flex flex-wrap items-center gap-2">
                    <span class="text-sm font-medium text-gray-700 whitespace-nowrap">Active Filters :</span>

                    <span *ngIf="priceFrom !== minPrice || priceTo !== maxPrice"
                        class="inline-flex items-center gap-1.5 rounded-full bg-[#D31148] px-3 py-1.5 text-xs font-semibold text-white whitespace-nowrap">
                        Price : {{ priceLabel }}
                        <button type="button" (click)="clearPriceFilter()"
                            class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none hover:bg-white/90 transition-colors">×</button>
                    </span>

                    <!-- Search and location hold free-form user text, so they get
                         max-w-full + wrapping instead of nowrap — a long address
                         otherwise runs straight off the edge of the card. -->
                    <span *ngIf="searchText"
                        class="inline-flex max-w-full items-center gap-1.5 rounded-2xl bg-[#D31148] px-3 py-1.5 text-xs font-semibold text-white">
                        <span class="min-w-0 break-words">Search: {{ searchText }}</span>
                        <button type="button" (click)="clearSearch()"
                            class="inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none hover:bg-white/90 transition-colors">×</button>
                    </span>

                    <span *ngIf="byDate"
                        class="inline-flex items-center gap-1.5 rounded-full bg-[#D31148] px-3 py-1.5 text-xs font-semibold text-white whitespace-nowrap">
                        From: {{ byDateDisplay || byDate }}
                        <button type="button" (click)="clearDateFilter()"
                            class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none hover:bg-white/90 transition-colors">×</button>
                    </span>

                    <span *ngIf="locationText"
                        class="inline-flex max-w-full items-center gap-1.5 rounded-2xl bg-[#D31148] px-3 py-1.5 text-xs font-semibold text-white">
                        <span class="min-w-0 break-words">📍 {{ locationText }}</span>
                        <button type="button" (click)="clearLocation()"
                            class="inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none hover:bg-white/90 transition-colors">×</button>
                    </span>

                    <span *ngFor="let cat of selectedCategories"
                        class="inline-flex items-center gap-1.5 rounded-full bg-[#D31148] px-3 py-1.5 text-xs font-semibold text-white whitespace-nowrap">
                        {{ cat }}
                        <button type="button" (click)="toggleCategory(cat)"
                            class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none hover:bg-white/90 transition-colors">×</button>
                    </span>

                    <button type="button" (click)="clearAll()"
                        class="text-sm font-semibold text-[#D31148] hover:underline whitespace-nowrap ml-1">
                        Clear all
                    </button>
                </div>
            </div>

            <div class="grid grid-cols-1 gap-5 lg:grid-cols-[300px_minmax(0,1fr)] xl:grid-cols-[340px_minmax(0,1fr)]">

                <!-- ── Sidebar ─────────────────────────────────────────────────── -->
                <aside class="rounded-2xl border border-[#e8e8e8] bg-white p-5 h-fit shadow-sm lg:sticky lg:top-24 lg:max-h-[calc(100vh-7rem)] lg:overflow-y-auto custom-scrollbar">
                    <button type="button" (click)="toggleMobileFilters()"
                        class="flex w-full items-center justify-between gap-3 text-left lg:pointer-events-none">
                        <h3 class="text-xl font-bold text-gray-700">Filter Options</h3>
                        <span
                            class="flex h-9 w-9 items-center justify-center rounded-full border border-[#e8e8e8] text-gray-500 transition-transform duration-200 lg:hidden"
                            [class.rotate-180]="showMobileFilters">
                            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </span>
                    </button>

                    <div class="lg:block" [ngClass]="showMobileFilters ? 'block' : 'hidden'">
                        <!-- Price Range -->
                        <div class="mt-5">
                            <div class="flex items-center justify-between mb-3">
                                <app-lable>Price</app-lable>
                                <span class="text-sm font-semibold text-[#D31148]">{{ priceLabel }}</span>
                            </div>
                            <div #sliderTrack class="relative h-5 flex items-center cursor-pointer select-none"
                                (mousedown)="onTrackMouseDown($event)" (touchstart)="onTrackTouchStart($event)">
                                <div class="absolute left-0 right-0 h-1.5 rounded-full bg-[#e8e8e8]"></div>
                                <div class="absolute h-1.5 rounded-full bg-[#D31148] pointer-events-none"
                                    [style.left.%]="fromPercent" [style.width.%]="toPercent - fromPercent"></div>
                                <div class="absolute w-[18px] h-[18px] rounded-full bg-[#D31148] border-2 border-white shadow-md pointer-events-none transition-transform duration-75"
                                    [class.scale-125]="draggingThumb === 'from'"
                                    style="transform:translateX(-50%);top:50%;margin-top:-9px;"
                                    [style.left.%]="fromPercent">
                                </div>
                                <div class="absolute w-[18px] h-[18px] rounded-full bg-[#D31148] border-2 border-white shadow-md pointer-events-none transition-transform duration-75"
                                    [class.scale-125]="draggingThumb === 'to'"
                                    style="transform:translateX(-50%);top:50%;margin-top:-9px;"
                                    [style.left.%]="toPercent">
                                </div>
                            </div>
                            <div class="flex justify-between text-xs text-gray-400 mt-1">
                                <span>£{{ minPrice }}</span><span>£{{ maxPrice }}</span>
                            </div>
                        </div>

                        <!-- Location -->
                        <div class="mt-6 border-t border-[#ededed] pt-5">
                            <app-lable>Location</app-lable>
                            <div class="relative mt-1">
                                <input #locationFilterInput type="text" [(ngModel)]="locationText" (keydown)="onLocationKeydown($event)"
                                    placeholder="Enter location"
                                    class="w-full rounded-xl border border-[#e8e8e8] bg-[#fafafa] px-4 py-2.5 pr-10 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-[#D31148] focus:ring-1 focus:ring-[#D31148] transition-colors" />
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                    class="absolute text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                    <path
                                        d="M11.9999 13.4295C13.723 13.4295 15.1199 12.0326 15.1199 10.3095C15.1199 8.58633 13.723 7.18945 11.9999 7.18945C10.2768 7.18945 8.87988 8.58633 8.87988 10.3095C8.87988 12.0326 10.2768 13.4295 11.9999 13.4295Z"
                                        stroke="currentColor" stroke-width="1.5" />
                                    <path
                                        d="M3.61971 8.49C5.58971 -0.169998 18.4197 -0.159997 20.3797 8.5C21.5297 13.58 18.3697 17.88 15.5997 20.54C13.5897 22.48 10.4097 22.48 8.38971 20.54C5.62971 17.88 2.46971 13.57 3.61971 8.49Z"
                                        stroke="currentColor" stroke-width="1.5" />
                                </svg>
                            </div>
                            <p class="mt-1 text-[11px] text-gray-400">Pick a suggestion, or press Enter to apply</p>
                        </div>

                        <!-- Search -->
                        <div class="mt-6 border-t border-[#ededed] pt-5">
                            <app-lable>Search</app-lable>
                            <div class="relative mt-1 search-dropdown-wrapper">
                                <input #searchInput type="text" [ngModel]="searchInputValue"
                                    (ngModelChange)="onSearchInputChange($event)" (focus)="onSearchFocus()"
                                    (keydown)="onSearchKeydown($event)" placeholder="Search events or #hashtags"
                                    class="w-full rounded-xl border border-[#e8e8e8] bg-[#fafafa] px-4 py-2.5 pr-10 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-[#D31148] focus:ring-1 focus:ring-[#D31148] transition-colors" />
                                <button *ngIf="searchInputValue" type="button" (click)="clearSearch()"
                                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#D31148] transition-colors">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2.5" stroke-linecap="round">
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                </button>
                                <svg *ngIf="!searchInputValue" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                    class="absolute text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                    <path
                                        d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <div *ngIf="showSearchDrop && trendingSuggestions.length > 0"
                                    class="absolute left-0 right-0 top-full mt-1 z-50 rounded-xl border border-[#e8e8e8] bg-white shadow-lg overflow-hidden">
                                    <div
                                        class="px-3 py-2 text-[11px] font-semibold text-gray-400 uppercase tracking-wide border-b border-[#f0f0f0]">
                                        {{ searchInputValue ? 'Suggestions' : 'Trending Searches' }}
                                    </div>
                                    <button *ngFor="let s of trendingSuggestions" type="button"
                                        (mousedown)="selectSuggestion(s)"
                                        class="flex w-full items-center gap-2.5 px-3 py-2.5 text-sm text-gray-700 hover:bg-[#fff5f7] hover:text-[#D31148] transition-colors text-left">
                                        <span *ngIf="s.startsWith('#')"
                                            class="flex h-5 w-5 items-center justify-center rounded-full bg-[#FFD4E0] text-[#D31148] text-[11px] font-bold flex-shrink-0">#</span>
                                        <svg *ngIf="!s.startsWith('#')" width="14" height="14" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="text-gray-400 flex-shrink-0">
                                            <circle cx="11" cy="11" r="8" />
                                            <path d="m21 21-4.35-4.35" />
                                        </svg>
                                        <span class="truncate">{{ s }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Date filter -->
                        <div class="mt-6 border-t border-[#ededed] pt-5">
                            <app-date-picker id="date-picker" label="By date" placeholder="Filter from start date"
                                (dateChange)="handleDateChange($event)" />
                        </div>

                        <!-- Categories -->
                        <div class="mt-6 border-t border-[#ededed] pt-5">
                            <app-lable>By Categories</app-lable>
                            <div class="relative mt-1">
                                <input type="text" [(ngModel)]="categorySearchText"
                                    placeholder="Search categories"
                                    class="w-full rounded-xl border border-[#e8e8e8] bg-[#fafafa] px-4 py-2 pr-9 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-[#D31148] focus:ring-1 focus:ring-[#D31148] transition-colors" />
                                <button *ngIf="categorySearchText" type="button" (click)="clearCategorySearch()"
                                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#D31148] transition-colors">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2.5" stroke-linecap="round">
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                </button>
                                <svg *ngIf="!categorySearchText" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    class="absolute text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                    <path
                                        d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="mt-3" style="height:215px;overflow-y:auto;">
                                <p *ngIf="filteredCategoryOptions.length === 0" class="text-sm text-gray-400 py-4 text-center">
                                    No categories found
                                </p>
                                <label *ngFor="let cat of filteredCategoryOptions"
                                    class="flex items-center gap-3 py-2 cursor-pointer group select-none">
                                    <div class="relative flex-shrink-0">
                                        <input type="checkbox" [checked]="selectedCategories.includes(cat.value)"
                                            (change)="toggleCategory(cat.value)" class="sr-only" />
                                        <div class="w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-200 cursor-pointer"
                                            [ngClass]="selectedCategories.includes(cat.value)
                                                ? 'bg-[#D31148] border-[#D31148]'
                                                : 'bg-white border-gray-300 group-hover:border-[#D31148]'">
                                            <svg *ngIf="selectedCategories.includes(cat.value)"
                                                class="w-3 h-3 text-white" viewBox="0 0 12 12" fill="none">
                                                <path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="2.2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <span class="text-sm transition-colors duration-200 cursor-pointer" [ngClass]="selectedCategories.includes(cat.value)
                                            ? 'text-[#D31148] font-semibold'
                                            : 'text-gray-600 group-hover:text-[#D31148]'">
                                        {{ cat.label }}
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </aside>

                <!-- ── Events masonry grid ─────────────────────────────────────── -->
                <div class="min-w-0">
                    <ng-container [ngTemplateOutlet]="eventsGrid"></ng-container>
                </div>
            </div>
        </ng-container>

        <ng-template #embeddedLayout>
            <ng-container [ngTemplateOutlet]="eventsGrid"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-container *ngIf="embedded; else fullEvents">
    <ng-container [ngTemplateOutlet]="eventsContent"></ng-container>
</ng-container>
<ng-template #fullEvents>
    <section class="min-h-screen bg-[#f3f3f3] px-3 pb-8 pt-5 sm:px-5 lg:px-8">
        <ng-container [ngTemplateOutlet]="eventsContent"></ng-container>
    </section>
</ng-template>

<!-- Reactions Modal — unchanged -->
<app-modal [isOpen]="isReactionOpen" (close)="closeReactionModal()" className="max-w-[700px]">
    <div class="relative w-full h-full flex flex-col bg-white dark:bg-gray-900 rounded-3xl overflow-hidden">
        <div class="flex-shrink-0 bg-white dark:bg-gray-900 border-b border-[#f0f0f0]">
            <div class="flex items-center gap-1 overflow-x-auto px-5 pt-5 pb-3 lg:px-8">
                <button (click)="setReactionFilter(null)"
                    class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
                    [class.text-[#D31148]]="activeReactionFilter === null"
                    [class.border-b-2]="activeReactionFilter === null"
                    [class.border-[#D31148]]="activeReactionFilter === null"
                    [class.text-gray-500]="activeReactionFilter !== null">
                    All <span class="font-bold">{{ reactionData?.total ?? 0 }}</span>
                </button>
                <ng-container *ngFor="let r of REACTIONS">
                    <button (click)="setReactionFilter(r.type)"
                        class="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
                        [class.text-[#D31148]]="activeReactionFilter === r.type"
                        [class.border-b-2]="activeReactionFilter === r.type"
                        [class.border-[#D31148]]="activeReactionFilter === r.type"
                        [class.text-gray-500]="activeReactionFilter !== r.type">
                        <span style="font-size:18px;line-height:1;">{{ r.emoji }}</span>
                        <span>{{ reactionData?.counts?.[r.type] ?? 0 }}</span>
                    </button>
                </ng-container>
            </div>
        </div>
        <div class="flex-1 overflow-y-auto px-5 py-4 lg:px-8">
            <div *ngIf="reactionsLoading" class="flex items-center justify-center py-12">
                <div class="h-8 w-8 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
            </div>
            <div *ngIf="!reactionsLoading" class="space-y-1">
                <div *ngFor="let item of filteredReactions"
                    class="flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-[#fafafa] transition-colors">
                    <div class="relative flex-shrink-0">
                        <img [src]="item.user?.profileImage?.urlSmall || avatarFallback(item.user?.displayName)"
                            class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]"
                            [alt]="item.user?.displayName" />
                        <span
                            class="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white text-[11px] shadow-sm"
                            [style.background]="getReactionConfig(item.type)?.bg">{{ item.emoji }}</span>
                    </div>
                    <div class="flex-1 min-w-0">
                        <div class="font-semibold text-gray-800 text-sm truncate">{{ item.user?.userName }}</div>
                        <div class="text-xs text-gray-400 truncate">{{ item.user?.displayName }}</div>
                    </div>
                    <div class="flex items-center gap-2 flex-shrink-0">

                        <!-- Friend request button -->
                        <button (click)="onModalFriendClick(item, $event)" *ngIf="!item.isMe"
                            [title]="friendButtonTitle(item.friendship.status ?? 'NONE')"
                            [disabled]="item.friendship.status === 'BLOCKED'"
                            class="flex items-center justify-center w-8 h-8 rounded-full border transition-colors disabled:opacity-40"
                            [ngClass]="item.friendship.status === 'FRIENDS'
                    ? 'border-emerald-500 text-emerald-500 hover:bg-emerald-50'
                    : item.friendship.status === 'PENDING_SENT'
                        ? 'border-orange-400 text-orange-400 hover:bg-orange-50'
                        : 'border-[#D31148] text-[#D31148] hover:bg-[#FFF0F3]'">

                            <!-- NONE: add friend -->
                            <svg *ngIf="!item.friendship.status || item.friendship.status === 'NONE'" width="15"
                                height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <line x1="19" y1="8" x2="19" y2="14" />
                                <line x1="22" y1="11" x2="16" y2="11" />
                            </svg>

                            <!-- PENDING_SENT: cancel -->
                            <svg *ngIf="item.friendship.status === 'PENDING_SENT'" width="15" height="15"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <line x1="17" y1="8" x2="23" y2="14" />
                                <line x1="23" y1="8" x2="17" y2="14" />
                            </svg>

                            <!-- PENDING_RECEIVED -->
                            <svg *ngIf="item.friendship.status === 'PENDING_RECEIVED'" width="15" height="15"
                                viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <polyline points="16 11 18 13 22 9" />
                            </svg>

                            <!-- FRIENDS: unfriend -->
                            <svg *ngIf="item.friendship.status === 'FRIENDS'" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <polyline points="16 11 18 13 22 9" />
                            </svg>

                            <!-- BLOCKED -->
                            <svg *ngIf="item.friendship.status === 'BLOCKED'" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                            </svg>

                        </button>

                        <!-- Follow / Unfollow button -->
                        <button (click)="onModalFollowClick(item, $event)" *ngIf="!item.isMe"
                            class="flex-shrink-0 px-3 py-0.5 text-xs font-semibold rounded-lg transition-colors"
                            [ngClass]="item.isFollowed
                    ? 'text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100'
                    : 'text-green-700 bg-green-100 border border-green-600 hover:bg-green-200'">
                            {{ item.isFollowed ? 'Unfollow' : 'Follow' }}
                        </button>

                    </div>
                </div>
                <div *ngIf="filteredReactions.length === 0"
                    class="flex flex-col items-center justify-center py-12 text-gray-400">
                    <span style="font-size:40px;">🤷</span>
                    <p class="mt-2 text-sm">No reactions yet</p>
                </div>
            </div>
        </div>
    </div>
</app-modal>

<div *ngIf="showCollabModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    (click)="closeCollaboratorsModal()">
    <div class="max-h-[80vh] w-full max-w-sm overflow-hidden rounded-2xl bg-white" (click)="$event.stopPropagation()">

        <div class="flex items-center justify-between border-b border-gray-200 p-4">
            <h3 class="text-lg font-bold">Collaborators</h3>
            <button (click)="closeCollaboratorsModal()" class="text-gray-400 transition-colors hover:text-gray-600">
                <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>

        <div class="max-h-[calc(80vh-80px)] overflow-y-auto">
            <div class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
                [routerLink]="['/profile', selectedEvent?.hostName, 'event']">
                <img [src]="selectedEvent?.hostAvatar" [alt]="selectedEvent?.hostName || 'Host'"
                    class="h-12 w-12 rounded-full border-2 border-white object-cover"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                <div class="min-w-0 flex-1">
                    <div class="truncate font-semibold text-gray-900">{{ selectedEvent?.hostName }}</div>
                    <div class="text-sm text-gray-500">Author</div>
                </div>
            </div>

            <div *ngFor="let collab of selectedEvent?.acceptedCollaborators"
                class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
                [routerLink]="['/profile', collab.userName, 'event']">
                <img [src]="collab.profileImage?.urlSmall" [alt]="collab.displayName"
                    class="h-12 w-12 rounded-full border-2 border-white object-cover"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                <div class="min-w-0 flex-1">
                    <div class="truncate font-semibold text-gray-900">@{{ collab.userName }}</div>
                    <div class="truncate text-sm text-gray-500">{{ collab.displayName }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showTaggedModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    (click)="closeTaggedPeopleModal()">
    <div class="max-h-[80vh] w-full max-w-sm overflow-hidden rounded-2xl bg-white" (click)="$event.stopPropagation()">

        <div class="flex items-center justify-between border-b border-gray-200 p-4">
            <h3 class="text-lg font-bold">Tagged People</h3>
            <button (click)="closeTaggedPeopleModal()" class="text-gray-400 transition-colors hover:text-gray-600">
                <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>

        <div class="max-h-[calc(80vh-80px)] overflow-y-auto">
            <div *ngFor="let tagged of selectedEvent?.mentions"
                class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
                [routerLink]="['/profile', tagged.userName, 'event']">
                <img [src]="tagged.profileImage?.urlSmall" [alt]="tagged.displayName"
                    class="h-12 w-12 rounded-full border-2 border-white object-cover"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                <div class="min-w-0 flex-1">
                    <div class="truncate font-semibold text-gray-900">@{{ tagged.userName }}</div>
                    <div class="truncate text-sm text-gray-500">{{ tagged.displayName }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-popup [isOpen]="showLoginPrompt" icon="user-add" title="Login Required"
    [message]="'To ' + loginPromptAction" [highlightedName]="loginPromptUserName"
    messageSuffix="you need to be logged in first" confirmLabel="Log In" cancelLabel="Close" (confirmed)="goToLogin()"
    (cancelled)="closeLoginPrompt()">
</app-confirmation-popup>

<app-friend-request-limit-popup [isOpen]="showFriendLimitPopup" [hours]="friendLimitHours"
    (closed)="showFriendLimitPopup = false"></app-friend-request-limit-popup>

<app-confirmation-popup [isOpen]="showUnfriendConfirm" icon="warning" title="Unfriend User"
    message="Are you sure you want to unfriend this user?" confirmLabel="Unfriend" cancelLabel="Cancel"
    (confirmed)="confirmUnfriend()" (cancelled)="cancelUnfriendConfirm()"></app-confirmation-popup>

<!-- Delete Event confirmation -->
<app-confirmation-popup [isOpen]="showDeleteEventConfirm" icon="warning" title="Delete Event"
    message="Are you sure you want to permanently delete this event?"
    confirmLabel="Delete" cancelLabel="Cancel" (confirmed)="doDeleteEvent()" (cancelled)="cancelDeleteEvent()">
</app-confirmation-popup>

<!-- Report Event -->
<app-report-modal [isOpen]="isReportModalOpen" targetLabel="Event" [isSubmitting]="isSubmittingReport"
    [errorMessage]="reportError" (submitted)="submitEventReport($event)" (cancelled)="closeReportModal()">
</app-report-modal>

<app-confirmation-popup [isOpen]="reportSuccessOpen" icon="info" title="Report Submitted"
    message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
    (cancelled)="closeReportSuccess()"></app-confirmation-popup>

<!-- Block User (safeword-confirm) -->
<app-block-user-confirm [isOpen]="showBlockUserConfirm" [targetName]="eventToBlockDisplayName"
    (confirmed)="confirmBlockEventUser()" (cancelled)="cancelBlockEventUser()"></app-block-user-confirm>

<style>
    /* CSS Grid masonry — 3 columns inside sidebar layout */
    .events-masonry-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-auto-rows: 10px;
        gap: 0 20px;
    }

    .events-masonry-grid.events-masonry-featured {
        grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: 1380px) {
        .events-masonry-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 1280px) {
        .events-masonry-grid.events-masonry-featured {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media (max-width: 900px) {

        .events-masonry-grid,
        .events-masonry-grid.events-masonry-featured {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 560px) {

        .events-masonry-grid,
        .events-masonry-grid.events-masonry-featured {
            grid-template-columns: 1fr;
        }
    }

    .events-masonry-item {
        align-self: start;
        min-width: 0;
        margin-bottom: 20px;
        animation: evFadeIn 0.35s ease both;
    }

    @keyframes evFadeIn {
        from {
            opacity: 0;
            transform: translateY(14px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
<!-- Share Sheet -->
<app-share-sheet *ngIf="activeShareItem" [config]="activeShareItem" [currentCount]="activeShareCount"
    (closed)="closeShareSheet()" (countUpdated)="onShareCountUpdated($event)">
</app-share-sheet>

<!-- Back to top button (standalone page only — hosts that embed this list add their own) -->
<app-scroll-to-top *ngIf="!embedded" />